import { Circle, Text } from 'native-base';
/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import React, { useCallback, useState } from 'react';
import { TwIcon, TwRow, TwStackedCard } from '@tw/tw-components-rn';

import { ProductGoodsDTO } from '@tw/clvip-api-gen';
import { styles } from '../../pages/gift-mall/styles';

interface GoodItemProps extends ProductGoodsDTO {
  buttons?: React.ReactNode;
  onPress?: () => void;
  style?: any;
  imageStyle?: any;
  subStyle?: any;
}

export const GoodItem = (props: GoodItemProps) => {
  return (
    <TwStackedCard
      style={props.style}
      imageStyle={props.imageStyle ?? styles.image}
      subStyle={props.subStyle ?? styles.subtitle}
      titleLines={1}
      mode={'quiet'}
      title={props.name}
      subtitle={
        props.isLimit ? (
          <TwRow space={1} justifyContent="left" alignItems="center">
            <Text style={styles.subtitle}>{'¥' + props.price}</Text>
            <Text style={styles.subtitleTag}>{'限' + props.chooseLimitMax + '份'}</Text>
          </TwRow>
        ) : (
          '¥' + props.price
        )
      }
      imageUrl={props?.showPicture?.url}
      header={''}
      buttons={props.buttons}
      onPress={() => {
        props.onPress?.();
      }}
    />
  );
};
